<template>
    <!-- how a CSV file for an import should be: the columns and what they take -->
    <div class="csv-help">
        <p>
            A <b>.csv</b> file, comma separated, with the column names in the first row.
            The easiest way: <b>Export CSV</b>, keep the header row and change or add rows below it.
        </p>
        <table class="csv-help__table">
            <tr v-for="column in columns" :key="column.name">
                <td><code>{{ column.name }}</code></td>
                <td>{{ column.text }}</td>
            </tr>
        </table>
        <p v-for="(note, index) in notes" :key="index" class="mb-1" v-html="note" />
    </div>
</template>

<script>
    export default {
        props: {
            columns: {
                type: Array,
                default: () => []
            },
            // extra lines under the columns (simple html, written in the code only)
            notes: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style scoped>
.csv-help p {
    margin-bottom: 10px;
}

.csv-help__table {
    width: 100%;
    margin-bottom: 10px;
    border-collapse: collapse;
}

.csv-help__table td {
    padding: 3px 8px 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    vertical-align: top;
}

.csv-help__table td:first-child {
    white-space: nowrap;
}
</style>
